// extracted by mini-css-extract-plugin
module.exports = {"NavItem":"NavItem_NavItem__3jMhW"};